import { useEffect, useMemo, useRef, useState } from "react";

export default function YearPicker({ value, onChange, maxYears = 16 }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const years = useMemo(() => {
    const current = new Date().getFullYear();
    return Array.from({ length: maxYears }, (_, i) => String(current - i));
  }, [maxYears]);

  useEffect(() => {
    if (!open) return undefined;

    const close = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", close);
    document.addEventListener("touchstart", close);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("touchstart", close);
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open]);

  const pickYear = (y) => {
    onChange(y);
    setOpen(false);
  };

  return (
    <div className="dash-year-picker" ref={rootRef}>
      <button
        type="button"
        className="dash-year-picker__btn"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label="Select year"
      >
        <span>{value}</span>
        <i className={`fas fa-chevron-down dash-year-picker__chev${open ? " is-open" : ""}`} />
      </button>

      {open && (
        <>
          <button
            type="button"
            className="dash-year-picker__backdrop"
            aria-label="Close year picker"
            onClick={() => setOpen(false)}
          />
          <div className="dash-year-picker__sheet" role="listbox" aria-label="Year options">
            <div className="dash-year-picker__sheet-head">
              <span>Select Year</span>
              <button type="button" className="dash-year-picker__close" onClick={() => setOpen(false)}>
                <i className="fas fa-times" />
              </button>
            </div>
            <ul className="dash-year-picker__list">
              {years.map((y) => (
                <li key={y}>
                  <button
                    type="button"
                    role="option"
                    aria-selected={y === value}
                    className={`dash-year-picker__option${y === value ? " is-active" : ""}`}
                    onClick={() => pickYear(y)}
                  >
                    {y}
                    {y === value && <i className="fas fa-check" />}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
